import { createFileRoute } from '@tanstack/react-router'

/**
 * Where an Ask Mitra bar question was asked (revamp mock, 2026-10-27): the
 * path to go back to and the bar's label for it, which the chat page draws as
 * "Back to {label}". Only an app path is kept — one leading slash, never two
 * — so a link cannot send the reader off the app through this.
 */
interface ChatSearch {
  back?: string
  label?: string
}

function chatSearch(search: Record<string, unknown>): ChatSearch {
  const { back, label } = search
  return {
    // `/\` too: a browser reads it as `//`, another origin.
    ...(typeof back === 'string' && /^\/(?![/\\])/.test(back) ? { back } : {}),
    ...(typeof label === 'string' && label.trim() !== '' ? { label: label.trim() } : {}),
  }
}

export const Route = createFileRoute('/_app/chat')({
  validateSearch: chatSearch,
  component: ChatScreen,
})

/**
 * Mitra's own page, at `/chat` — not `/mitra`, which the dev server proxies
 * to the engine. The chat itself is the panel AppShell mounts once, so a
 * conversation outlives every navigation; there that panel takes the
 * whole main area (see `useMitraRoute`). Nothing of its own to draw: this
 * route only gives the chat an address, so Back leaves it and a link or a
 * reload lands on it.
 */
function ChatScreen() {
  return null
}
